import { z } from 'zod'
import type { CompanyContact } from '../../models/CompanyContact'
import type { Contact } from '~/domain/shared/contacts/models/Contact'
import { ContactDTO, mapContactToDTO, mapDTOToContact } from '~/domain/dashboard/customer/gateways/DTOs/ContactDTO'

export const CompanyContactDTO = z.object({
  name: z.string().nullish(),
  contacts: ContactDTO.array().nullish()
})

export type CompanyContactDTO = z.infer<typeof CompanyContactDTO>

export function filterContactsForApi (contacts: CompanyContact['contacts'] | undefined): Contact[] {
  return contacts?.filter(contact => contact.value != null && contact.value !== '') ?? []
}

export function mapCompanyContactToDTO (model: CompanyContact): CompanyContactDTO {
  return {
    name: model.name,
    contacts: filterContactsForApi(model.contacts).map(mapContactToDTO)
  }
}

export function mapDTOToCompanyContact (dto: CompanyContactDTO): CompanyContact {
  return {
    name: dto.name ?? '',
    contacts: dto.contacts?.map(mapDTOToContact) ?? []
  }
}
